<template>
    <div class="content">
        <van-form @submit="onSubmit">
            <div class="work_status plc plcgo">
                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="form.work_status"
                    label="目前工作状态"
                    placeholder="请选择"
                    @click="showPicker = true"
                    :rules="[{ required: true, message: '请选择目前工作状态！' }]"
                />
                <van-popup v-model="showPicker" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columns"
                        @confirm="onConfirm"
                        @cancel="showPicker = false"
                    />
                </van-popup>
                <img :src="require('@/assets/img/go.png')" alt="">
            </div>
            <div class="position plc plcgo">
                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="form.apply_position_id"
                    label="应聘职位"
                    placeholder="请选择"
                    @click="positionPicker = true"
                    :rules="[{ required: true, message: '请选择目应聘职位！' }]"
                />
                <van-popup v-model="positionPicker" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="positioncolumns"
                        @confirm="positionConfirm"
                        @cancel="positionPicker = false"
                    />
                </van-popup>
                <img :src="require('@/assets/img/go.png')" alt="">
            </div>
            <div class="years plc plcgo">
                <van-field v-model="form.work_experience" type="digit" label="工作年限" placeholder="请输入(仅数字)" :rules="[{ required: true }]"/>
                <span>年</span>
            </div>
            <div class="work_status plc plcgo">
                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="form.expect_salary_id"
                    label="期望工资"
                    placeholder="请选择"
                    @click="moneyPicker = true"
                    :rules="[{ required: true, message: '请选择期望工资！' }]"
                />
                <van-popup v-model="moneyPicker" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="moneycolumns"
                        @confirm="moneyConfirm"
                        @cancel="moneyPicker = false"
                    />
                </van-popup>
                <img :src="require('@/assets/img/go.png')" alt="">
            </div>
            <div class="date plc plcgo">
                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="form.expect_date_char"
                    label="可到岗时间"
                    placeholder="请选择"
                    @click="datePicker = true"
                    :rules="[{ required: true, message: '请选择可到岗时间！' }]"
                />
                <van-popup v-model="datePicker" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="datecolumns"
                        @confirm="dateConfirm"
                        @cancel="datePicker = false"
                    />
                </van-popup>
                <img :src="require('@/assets/img/go.png')" alt="">
            </div>
            <div class="referrer" style="position: relative;">
                <van-field v-model="referrer" type="text" label="本公司推荐人" placeholder="选填"/>
                <!-- <van-field v-model="referrer" type="text" label="本公司推荐人" placeholder="选填" @blur="blurReferrer"/> -->
                <div class="referrer_content" style="position: absolute;" v-show="isReferrer && referrer">
                    <span v-for="(v,i) in referrerArr" :key="i" @click="checkReferrer(v)">{{v.real_name}}</span>
                </div>
            </div>
            <div style="margin: 16px;">
                <van-button round block type="danger" native-type="submit" ref="savebtn">下一步</van-button>
            </div>
        </van-form>
        <load :loading="loading"></load>
    </div>
</template>

<script>
import { getPositionApi,getSalaryApi,editApplyJobApi,getApplyJobByResumeIdApi,getEduExperienceListApi,getReferrerApi } from '@/api/interview'
import Load from "@/components/Loading"
import { Toast } from 'vant';
    export default {
        data(){
            return {
                form:{},
                subForm:{},
                showPicker:false,
                columns: [{id:1,text:"离职"},{id:2,text:"在职"}],//工作状态,
                positionPicker:false,
                positioncolumns:[],  //应聘职位
                moneyPicker:false,
                moneycolumns:[],  //期望薪资
                datePicker:false,
                datecolumns:["一周内","二周内","30天内"],  //到岗时间
                id:sessionStorage.getItem('ID') || 0,  //用户ID
                loading:false,
                isReferrer:false,
                referrer:"",
                referrerArr:[],
            }
        },
        methods:{
            // 选择推荐人
            checkReferrer(v){
                this.referrer = v.real_name
                this.subForm.referrer_id = v.id
                this.subForm.referrer_uid = v.uid
                this.subForm.referrer_name = v.real_name
                this.isReferrer = false
            },
            // 模糊查询推荐人
            getReferrer(newVal){
                const params = {
                    name:newVal
                }
                const isExistence = this.referrerArr.find(v=>{
                    return v.real_name == this.referrer
                })
                if(isExistence){
                    return
                }
                getReferrerApi(params).then(res=>{
                    if(res.errNo===0){
                        if(res.result.length > 0){
                            this.referrerArr = res.result
                            this.isReferrer = true
                        }else {
                            this.referrerArr = []
                            this.isReferrer = false
                        }
                    }
                })
            },
            // 推荐人失去焦点
            blurReferrer(){
                this.isReferrer = false
            },
            // 提交
            onSubmit(){
                const params = {
                    resume_id:this.id,
                    ...this.form,
                    ...this.subForm,
                    referrer_uid:this.referrer ? (this.subForm.referrer_uid ? this.subForm.referrer_uid : 0) : 0,
                    work_experience:this.form.work_experience,
                    expect_date_char:this.form.expect_date_char,
                    referrer_name:this.referrer
                }
                editApplyJobApi(params).then(res=>{
                    if(res.errNo===0){
                        getEduExperienceListApi({resume_id:this.id}).then(r=>{
                            if(this.$route.query.edit){
                                this.$router.push({path:'/interviews/resume'})
                            }else if(r.result.length>0){
                                this.$router.push({path:'/interviews/educationlist'})
                            }else {
                                this.$router.push({path:'/interviews/education'})
                            }
                        })
                    } else {
                        Toast('提交失败,请检查填写信息');
                    }
                })
            },
            // 工作状态
            onConfirm(value){
                this.showPicker = false;
                this.form.work_status = value.text;
                this.subForm.work_status = value.id;
            },
            // 应聘职位
            positionConfirm(value){
                this.positionPicker = false;
                this.form.apply_position_id = value.text;
                this.subForm.apply_position_id = value.id;
            },
            // 期望薪资
            moneyConfirm(value){
                this.moneyPicker = false;
                this.form.expect_salary_id = value.text;
                this.subForm.expect_salary_id = value.id;
            },
            // 到岗时间
            dateConfirm(value){
                this.datePicker = false;
                this.form.expect_date_char = value;
            },
            async getData(){
                let { result } = await getApplyJobByResumeIdApi({resume_id:this.id})
                let temform = {
                    ...result,
                    work_status:result.work_status ? result.work_status ==1 ? "离职" : "在职" : ''
                }
                this.referrer = result.referrer_name
                this.subForm = {...result}
                let position = await getPositionApi()
                let salary = await getSalaryApi()
                if(position.errNo===0 && salary.errNo===0){
                    temform.apply_position_id = position.result[temform.apply_position_id]
                    temform.expect_salary_id = salary.result[temform.expect_salary_id]
                    for(let key in position.result){
                        this.positioncolumns.push({
                            id:key,
                            text:position.result[key]
                        })
                    }
                    for(let key in salary.result){
                        this.moneycolumns.push({
                            id:key,
                            text:salary.result[key]
                        })
                    }
                }
                this.form = temform
                this.loading = false
                this.isReferrer = false
            }
        },
        created(){
            const id = sessionStorage.getItem('ID') || 0
            this.id = id
            if(id){
                this.loading = true
            }
            this.getData();
        },
        mounted() {
            if(this.$route.query.edit){
                this.$refs['savebtn'].innerHTML="保存"
            }
        },
        watch:{
            // referrer(newVal,oldVal){
            //     this.getReferrer(newVal)
            // }
        },
        components: {
            Load
        }
    }
</script>

<style scoped lang='less'>
/deep/ .van-cell {
  display: block;
}
/deep/ .van-field__error-message {
  text-align: center;
}
/deep/ .van-cell::after {
  border-bottom: 1px solid #999999;
}
.years {
    position: relative;
    span {
        position: absolute;
        top: 60px;
        right: 30px;
        font-size: 30px;
    }
    
}
.plc {
    position: relative;
    &::after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 30px;
    bottom: 0;
    left: 30px;
    border-bottom: 1px solid #999999;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}

.plcgo {
    img {
        width: 18px;
        height: 31px;
        position: absolute;
        right: 30px;
        top: 54px;
    }
}
/deep/ .van-image{
    width: 100px;
    height: 100px;
    img{
        border-radius: 50%;
    }
}
/deep/ .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
/deep/ .van-button--block {
  border-radius: 10px;
}
.referrer_content{
    z-index: 9999;
    width: 400px;
    padding: 0 20px;
    margin: 0 auto;
    height: 300px;
    overflow: hidden;
    overflow-y: scroll;
    background: #ffffff;
    &::-webkit-scrollbar {
        width: 6px;
    }
    span {
        font-size: 26px;
        display: block;
        padding: 10px 30px;
    }
}
</style>